import { TypPripomienkyEnum } from 'pripomienky-web-ts-axios';
import MultiChoiceItem from '../../types/MultiChoiceItem';

enum TypPripomienky {
  OBYCAJNA = 'Obyčajná pripomienka',
  ZASADNA = 'Zásadná pripomienka',
  HROMADNA = 'Hromadná pripomienka verejnosti',
}

export default TypPripomienky;

export const obycajnaTypPripomienkyMultichoice: MultiChoiceItem[] = [
  { id: 'obycajna', label: TypPripomienky.OBYCAJNA, checked: true },
  { id: 'zasadna', label: TypPripomienky.ZASADNA, checked: true },
];

export const hromadnaTypPripomienkyMultichoice: MultiChoiceItem[] = [
  { id: 'hromadna', label: TypPripomienky.HROMADNA, checked: true },
];

export const stringToGeneratedMap = new Map([
  ['obycajna', TypPripomienkyEnum.Obycajna],
  ['zasadna', TypPripomienkyEnum.Zasadna],
  ['hromadna', TypPripomienkyEnum.Hromadna],
]);

export const generatedToTypPripomienkyMap = new Map([
  [TypPripomienkyEnum.Obycajna, TypPripomienky.OBYCAJNA],
  [TypPripomienkyEnum.Zasadna, TypPripomienky.ZASADNA],
  [TypPripomienkyEnum.Hromadna, TypPripomienky.HROMADNA],
]);

export function generatedToTypPripomienky(generated: TypPripomienkyEnum): TypPripomienky {
  return generatedToTypPripomienkyMap.get(generated);
}

export function stringToGeneratedTyp(typ: string): TypPripomienkyEnum {
  return stringToGeneratedMap.get(typ);
}
